import findMyPictureDayForm from 'html/find-my-picture-day/find-my-picture-day-form.html';
import App from 'app/app.js';
import 'app/directive/LtPictureDayFormCtrl.js';

function LtPictureDayFormDirective() {
  return {
    restrict: 'E',
    scope: {
      accessCode: '=',
      subjectLastName: '=',
      childGrade: '=',
      cancelLabel: '=',
      firstName: '=',
      lockPortraitId: '=',
      relationshipDisclaimer: '=',
      onCancel: '&',
      onContinue: '&',
      canContinue: '=',
      pictureDayCopy: '=',
      portraitId: '=',
      pageScope: '=',
      isFindMyPictureDayShown: '=',
      isNeedHelpModalShown: '=',
      fromBannerPage: '='
    },
    template: findMyPictureDayForm,
    controller: 'LtPictureDayFormCtrl',
    controllerAs: 'pictureDayForm'
  };
}
App.directive('ltPictureDayForm', [LtPictureDayFormDirective]);
